// extracted by mini-css-extract-plugin
module.exports = {"forum_tags":"forum_tags--17BKG","forum_tag":"forum_tag--1-md7","forum_tag_link":"forum_tag_link--2x0wR"};